<template>
  <div style="max-width: 1200px; margin: auto">
    <v-container class="py-10">
      <v-container class="px-0">
        <h2>
          Sparen Sie viel Zeit und Aufwand! Probieren Sie TRADANA jetzt aus.
        </h2>
      </v-container>
      <tradana-mail-entry position="2"></tradana-mail-entry>
    </v-container>
  </div>
</template>

<script>
import MailEntry from '@/components/global/MailEntry.vue'

export default {
  components: {
    TradanaMailEntry: MailEntry
  }  
}
</script>
